import React, {Component} from 'react';

class FilterButton extends Component {
    render() {
        const {bsRole, bsClass, ...props} = this.props;

        return (
            <button type="button" className="btn btn-default" {...props}>
                <i className="fa fa-filter"/>
            </button>
        );
    }
}

export default FilterButton;


// WEBPACK FOOTER //
// ./src/datagrid/FilterButton.js